import { Stage } from './Viewer.types';

export const log = (stage: Stage | string, data?: Json) => {
  // console.log('Stage =>', stage);
};
